import { RootState } from '../../RootState';
import { StateGraphqlHostSettings } from '@spa/lib/store/settings/SettingsState';

const selectGraphqlPublicHostSettings = (state: RootState): StateGraphqlHostSettings => {
  const settings = state.settings.settings;

  if (settings === null) {
    throw new Error('Graphql settings should be initialized.');
  }

  return settings.graphqlSettings.publicHost;
};

export default selectGraphqlPublicHostSettings;
